import _taggedTemplateLiteralLoose from "@babel/runtime/helpers/esm/taggedTemplateLiteralLoose";

function _templateObject7() {
  var data = _taggedTemplateLiteralLoose(["\n  ", "\n  ", "\n  ", "\n"]);

  _templateObject7 = function _templateObject7() {
    return data;
  };

  return data;
}

function _templateObject6() {
  var data = _taggedTemplateLiteralLoose(["\n  ", "\n  ", "\n  ", "\n"]);

  _templateObject6 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5() {
  var data = _taggedTemplateLiteralLoose(["\n  ", "\n  ", "\n  ", "\n"]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteralLoose(["\n  ", "\n  ", "\n  ", "\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteralLoose(["\n  ", "\n  ", "\n  ", "\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteralLoose(["\n  ", "\n  ", "\n  ", "\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteralLoose(["\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import { css } from 'styled-components';
import { mixin } from '../helpers/mixins';
import { isDefined } from '../helpers/defined';
import { ellipsisStyle } from '../tokens/ellipsis';
import { styleForBreakpoints } from '../helpers/media-style';
import { size } from '../style/size';
import { height } from '../style/height';
import { width } from '../style/width';
import { minWidth } from '../style/min-width';
import { maxWidth } from '../style/max-width';
import { minHeight } from '../style/min-height';
import { maxHeight } from '../style/max-height';
import { fullWidth } from '../style/full-width';
import { fullHeight } from '../style/full-height';
import { boxSizing } from '../style/box-sizing';
import { zIndex } from '../style/z-index';
import { padding } from '../style/padding';
import { paddingLeft } from '../style/padding-left';
import { paddingRight } from '../style/padding-right';
import { paddingBottom } from '../style/padding-bottom';
import { paddingTop } from '../style/padding-top';
import { paddingVertical } from '../style/padding-vertical';
import { paddingHorizontal } from '../style/padding-horizontal';
import { margin } from '../style/margin';
import { marginLeft } from '../style/margin-left';
import { marginRight } from '../style/margin-right';
import { marginBottom } from '../style/margin-bottom';
import { marginTop } from '../style/margin-top';
import { marginVertical } from '../style/margin-vertical';
import { marginHorizontal } from '../style/margin-horizontal';
export var fullHeightMixin = mixin(fullHeight, ['fullHeight', '$fullHeight']);
export var fullHeightKeys = ['fullHeight'];
export var fullWidthMixin = mixin(fullWidth, ['fullWidth', '$fullWidth']);
export var fullWidthKeys = ['fullWidth'];
export var ellipsisDisplayMixin = function ellipsisDisplayMixin(_ref) {
  var _ref$ellipsis = _ref.ellipsis,
      ellipsis = _ref$ellipsis === void 0 ? false : _ref$ellipsis,
      _ref$$ellipsis = _ref.$ellipsis,
      $ellipsis = _ref$$ellipsis === void 0 ? false : _ref$$ellipsis;
  return (
    /* prettier-ignore */
    ellipsis || $ellipsis ? "\n    display: inline-block;\n    " + ellipsisStyle + "\n  " : ''
  );
};
export var ellipsisMixin = function ellipsisMixin(_ref2) {
  var _ref2$ellipsis = _ref2.ellipsis,
      ellipsis = _ref2$ellipsis === void 0 ? false : _ref2$ellipsis,
      _ref2$$ellipsis = _ref2.$ellipsis,
      $ellipsis = _ref2$$ellipsis === void 0 ? false : _ref2$$ellipsis;
  return ellipsis || $ellipsis ? ellipsisStyle : '';
};
export var ellipsisKeys = ['ellipsis'];
export var zIndexMixin = mixin(zIndex, ['zIndex', '$zIndex']);
export var zIndexKeys = ['zIndex'];
export var heightMixin = mixin(height, ['height', '$height', 'h', '$h']);
export var heightKeys = ['height', 'h'];
export var widthMixin = mixin(width, ['width', '$width', 'w', '$w']);
export var widthKeys = ['width', 'w'];
export var minHeightMixin = mixin(minHeight, ['minHeight', '$minHeight']);
export var minHeightKeys = ['minHeight'];
export var minWidthMixin = mixin(minWidth, ['minWidth', '$minWidth']);
export var minWidthKeys = ['minWidth'];
export var maxHeightMixin = mixin(maxHeight, ['maxHeight', '$maxHeight']);
export var maxHeightKeys = ['maxHeight'];
export var maxWidthMixin = mixin(maxWidth, ['maxWidth', '$maxWidth']);
export var maxWidthKeys = ['maxWidth'];
export var sizeMixin = css(_templateObject(), mixin(size, ['size', '$size', 's', '$s']), heightMixin, widthMixin, minHeightMixin, minWidthMixin, maxHeightMixin, maxWidthMixin);
export var sizeKeys = ['size', 's'].concat(heightKeys, widthKeys, minHeightKeys, maxHeightKeys, minWidthKeys, maxWidthKeys);
export var marginVerticalMixin = css(_templateObject2(), function (_ref3) {
  var _ref4;

  var value = _ref3.marginVertical,
      mv = _ref3.mv,
      my = _ref3.my;
  return (isDefined(value) || isDefined(mv) || isDefined(my)) && marginVertical((_ref4 = value != null ? value : mv) != null ? _ref4 : my);
}, function (_ref5) {
  var value = _ref5.marginBottom,
      mb = _ref5.mb;
  return (isDefined(value) || isDefined(mb)) && marginBottom(value != null ? value : mb);
}, function (_ref6) {
  var value = _ref6.marginTop,
      mt = _ref6.mt;
  return (isDefined(value) || isDefined(mt)) && marginTop(value != null ? value : mt);
});
export var paddingVerticalMixin = css(_templateObject3(), function (_ref7) {
  var _ref8;

  var value = _ref7.paddingVertical,
      pv = _ref7.pv,
      py = _ref7.py;
  return (isDefined(value) || isDefined(pv) || isDefined(py)) && paddingVertical((_ref8 = value != null ? value : pv) != null ? _ref8 : py);
}, function (_ref9) {
  var value = _ref9.paddingBottom,
      pb = _ref9.pb;
  return (isDefined(value) || isDefined(pb)) && paddingBottom(value != null ? value : pb);
}, function (_ref10) {
  var value = _ref10.paddingTop,
      pt = _ref10.pt;
  return (isDefined(value) || isDefined(pt)) && paddingTop(value != null ? value : pt);
});
export var marginVerticalKeys = ['marginVertical', 'marginBottom', 'marginTop', 'mv', 'my', 'mb', 'mt'];
export var paddingVerticalKeys = ['paddingVertical', 'paddingBottom', 'paddingTop', 'pv', 'py', 'pb', 'pt'];
export var marginHorizontalMixin = css(_templateObject4(), function (_ref11) {
  var _ref12;

  var value = _ref11.marginHorizontal,
      mh = _ref11.mh,
      mx = _ref11.mx;
  return (isDefined(value) || isDefined(mh) || isDefined(mx)) && marginHorizontal((_ref12 = value != null ? value : mh) != null ? _ref12 : mx);
}, function (_ref13) {
  var value = _ref13.marginLeft,
      ml = _ref13.ml;
  return (isDefined(value) || isDefined(ml)) && marginLeft(value != null ? value : ml);
}, function (_ref14) {
  var value = _ref14.marginRight,
      mr = _ref14.mr;
  return (isDefined(value) || isDefined(mr)) && marginRight(value != null ? value : mr);
});
export var paddingHorizontalMixin = css(_templateObject5(), function (_ref15) {
  var _ref16;

  var value = _ref15.paddingHorizontal,
      ph = _ref15.ph,
      px = _ref15.px;
  return (isDefined(value) || isDefined(ph) || isDefined(px)) && paddingHorizontal((_ref16 = value != null ? value : ph) != null ? _ref16 : px);
}, function (_ref17) {
  var value = _ref17.paddingLeft,
      pl = _ref17.pl;
  return (isDefined(value) || isDefined(pl)) && paddingLeft(value != null ? value : pl);
}, function (_ref18) {
  var value = _ref18.paddingRight,
      pr = _ref18.pr;
  return (isDefined(value) || isDefined(pr)) && paddingRight(value != null ? value : pr);
});
export var marginHorizontalKeys = ['marginHorizontal', 'marginLeft', 'marginRight', 'mh', 'mx', 'ml', 'mr'];
export var paddingHorizontalKeys = ['paddingHorizontal', 'paddingLeft', 'paddingRight', 'ph', 'px', 'pl', 'pr'];
export var marginMixin = css(_templateObject6(), marginVerticalMixin, marginHorizontalMixin, function (_ref19) {
  var value = _ref19.margin,
      m = _ref19.m;
  return (isDefined(value) || isDefined(m)) && margin(value != null ? value : m);
});
export var paddingMixin = css(_templateObject7(), paddingVerticalMixin, paddingHorizontalMixin, function (_ref20) {
  var value = _ref20.padding,
      p = _ref20.p;
  return (isDefined(value) || isDefined(p)) && padding(value != null ? value : p);
});
export var marginKeys = ['margin', 'm'].concat(marginHorizontalKeys, marginVerticalKeys);
export var paddingKeys = ['padding', 'p'].concat(paddingHorizontalKeys, paddingVerticalKeys);
export var relativeMixin = function relativeMixin(_ref21) {
  var _ref21$relative = _ref21.relative,
      relative = _ref21$relative === void 0 ? false : _ref21$relative,
      _ref21$$relative = _ref21.$relative,
      $relative = _ref21$$relative === void 0 ? false : _ref21$$relative;
  return relative || $relative ? "position: relative;" : '';
};
export var relativeKeys = ['relative'];
export var $showMixin = function $showMixin(_ref22) {
  var _ref22$$show = _ref22.$show,
      $show = _ref22$$show === void 0 ? true : _ref22$$show;
  return styleForBreakpoints($show, function ($show) {
    return !$show ? "display: none;" : '';
  });
};
export var $hideMixin = function $hideMixin(_ref23) {
  var _ref23$$hide = _ref23.$hide,
      $hide = _ref23$$hide === void 0 ? false : _ref23$$hide;
  return styleForBreakpoints($hide, function ($hide) {
    return $hide ? "display: none;" : '';
  });
};
export var showMixin = function showMixin(_ref24) {
  var _ref24$show = _ref24.show,
      show = _ref24$show === void 0 ? true : _ref24$show;
  return styleForBreakpoints(show, function (show) {
    return !show ? "display: none;" : '';
  });
};
export var hideMixin = function hideMixin(_ref25) {
  var _ref25$hide = _ref25.hide,
      hide = _ref25$hide === void 0 ? false : _ref25$hide;
  return styleForBreakpoints(hide, function (hide) {
    return hide ? "display: none;" : '';
  });
};
export var boxSizingMixin = mixin(boxSizing, ['boxSizing', 'sizing'], 'border-box');
export var boxSizingKeys = ['boxSizing', 'sizing'];